import React from "react";
import { FcClearFilters } from "react-icons/fc";
import './Presentation.css';

function Presentation() {
  return (
    <div className="presentationSection">
      <h1>My Todo List</h1>
      <h3>Create your today goals and keep an eye on it!</h3>
      <img
        className="presentationImage"
        src="https://cdni.iconscout.com/illustration/premium/thumb/concept-of-task-achievement-and-task-list-1917435-1632708.png"
        alt=""
      />
      <p>* This list is stored in the LocalStorage of your browser!</p>
    </div>
  );
}

export { Presentation };